import { fontSizes, pdfsPath } from '../../constants/constants';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewReverse from '../../components/ViewReverse';
import ViewItems from '../../components/ViewItems';
import CreateAccountFunctional from './index.function';
import CustomCheckbox from '../../components/CustomCheckbox';
import AuthWrapper from '../../components/AuthWrapper';
import { Formik } from 'formik';
import { create_account_schema, create_account_validation_schema } from '../../validations_schemas/create_account_validation_schema';
import images from '../../constants/images';
import { Dropdown, RowView } from '../../components';
import { ErrorText, PhoneInput } from '../CorporateForm/components';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';
import Language from '../../components/Language';
import { useEffect, useRef } from 'react';

const CreateAccount = () => {
  const {
    TextWeight,
    authLoading,
    onSubmit,
    getContentKey,
    corporate_all_types_dropdowns,
    is_corporate,
    isArabic,
    formikRef,
  } = CreateAccountFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => window.open(process.env.REACT_APP_JOIN_US_LINK, '_self')} />

        <RowView className='justify-between items-center'>
          <img src={images.textLogo} width={70} className='mt-10' />
          <Language isLogin />
        </RowView>

        <Formik
          innerRef={formikRef}
          validationSchema={create_account_validation_schema}
          initialValues={create_account_schema}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values) => onSubmit(values, false)}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, values, touched, setFieldTouched, errors }) => {
            const isValid = values?.phoneNumber && (!is_corporate || values?.applicantType) && values?.terms_and_conditions;
            // const isValid = values?.phoneNumber && (!is_corporate || (values?.applicantType && values?.companyType)) && values?.terms_and_conditions;

            return (
              <>
                <Text text={getContentKey('open_new_account')} weight={TextWeight.semiBold} size={fontSizes.h18} className={'mb-5 mt-10'} />
                <div className='w-full flex flex-col'>
                  <Text text={getContentKey('phoneNumber')} className='mb-1' size={fontSizes.h14} isRequired={true} />
                  <PhoneInput
                    value={values?.phoneNumber}
                    onChange={(val) => {
                      setFieldValue('phoneNumber', val)
                      setFieldTouched('phoneNumber', true, false)
                    }}
                  />
                  <ErrorText text={getContentKey(touched?.phoneNumber ? errors?.phoneNumber : '')} />
                </div>

                {is_corporate && (
                  <>
                    <Dropdown
                      label={getContentKey('applicantType')}
                      placeholder={getContentKey('placeholder_applicantType')}
                      options={corporate_all_types_dropdowns?.applicantTypes}
                      selectedValue={values?.applicantType}
                      valueKey={'name'}
                      isRequired={true}
                      onSelect={(val) => {
                        setFieldValue('applicantType', val);
                      }}
                      className={'mt-4'}
                    />
                    {/* <Dropdown
                      label={getContentKey('companyType')}
                      placeholder={getContentKey('placeholder_companyType')}
                      options={corporate_all_types_dropdowns?.companyTypes}
                      selectedValue={values?.companyType}
                      valueKey={'name'}
                      isRequired={true}
                      onSelect={(val) => {
                        setFieldValue('companyType', val);
                      }}
                      className={'mt-4'}
                    /> */}
                  </>
                )}

                {/* <ViewReverse className='gap-7 w-full'>
                  <CustomCheckbox
                    isChecked={values?.terms_and_conditions}
                    label={getContentKey('i_understand_and_agree')}
                    secondText={getContentKey('termsand_conditions')}
                    className={'mt-4'}
                    onClick={() => setFieldValue('terms_and_conditions', !values?.terms_and_conditions)}
                    onPressSecondText={() => window.open(pdfsPath.terms_conditions, '_blank')}
                  />
                </ViewReverse> */}

                {isArabic ? (
                  <ViewReverse className='gap-7 w-full'>
                    <CustomCheckbox
                      isChecked={values?.terms_and_conditions}
                      label={
                        <div className='flex items-center gap-1'>
                          <Text
                            text={getContentKey('terms_before')}
                            size={fontSizes.h14}
                            weight={TextWeight.light}
                          />
                          <Text
                            text={getContentKey('terms_text')}
                            size={fontSizes.h14}
                            color={'text-primary'}
                            weight={TextWeight.bold}
                            className={'mx-1 cursor-pointer'}
                            onClick={() => {
                              setFieldValue('terms_and_conditions', !values?.terms_and_conditions)
                              window.open(pdfsPath.terms_conditions, '_blank')
                            }}
                          />
                          <Text
                            text={getContentKey('terms_after')}
                            size={fontSizes.h14}
                            weight={TextWeight.light}
                          />
                        </div>
                      }
                      className={'mt-4'}
                      onClick={() => setFieldValue('terms_and_conditions', !values?.terms_and_conditions)}
                      onPressSecondText={() => window.open(pdfsPath.terms_conditions, '_blank')}
                    />
                  </ViewReverse>
                ) : (
                  <ViewReverse className='gap-7 w-full'>
                    <CustomCheckbox
                      isChecked={values?.terms_and_conditions}
                      label={getContentKey('i_understand_and_agree')}
                      secondText={getContentKey('termsand_conditions')}
                      className={'mt-4'}
                      onClick={() => setFieldValue('terms_and_conditions', !values?.terms_and_conditions)}
                      onPressSecondText={() => window.open(pdfsPath.terms_conditions, '_blank')}
                    />
                  </ViewReverse>
                )}

                <ViewItems className={'w-full gap-1 mt-4'}>
                  <Button
                    text={getContentKey('submit_btn')}
                    className={'mt-6 my-2 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    type={'submit'}
                    isDisabled={!isValid}
                  />
                </ViewItems>
              </>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default CreateAccount;
